import React from 'react'
import { Route, Routes, useLocation } from 'react-router-dom'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { NavTabs } from '@components/common/NavTabs'
import { PageLayout } from '@components/common/PageLayout'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions/useDashboardPermissions'
import { Button, ButtonGroup, ToolbarButton, useMediaQueryContext } from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import { PostsFilterContainer } from './modules/PostsFilter'
import { PostsSearch } from './modules/PostsSearch'
import { PublishedPosts } from './modules/PublishedPosts'
import { ScheduledPosts } from './modules/ScheduledPosts'

export const Posts = () => {
  const media = useMediaQueryContext()
  const { pathname } = useLocation()
  const { hasPermission } = useDashboardPermissions()

  const getNavbarTabs = () => {
    return [
      {
        label: 'Published',
        to: routing.memberships.posts.self,
        element: <PublishedPosts />,
      },
      {
        label: 'Scheduled',
        to: routing.memberships.posts.scheduled.all,
        element: <ScheduledPosts />,
      },
    ]
  }

  const getToolbarContent = () => {
    if (!media.tablet) {
      return (
        <ButtonGroup space="medium">
          {hasPermission('memberships.post.create') && (
            <ToolbarButton
              label="Create new post"
              icon={PlusIcon}
              to={routing.memberships.posts.create}
            />
          )}
          <PostsFilterContainer />
        </ButtonGroup>
      )
    }

    return (
      <ButtonGroup space="medium">
        <PostsFilterContainer />
        <PostsSearch />
        {hasPermission('memberships.post.create') && (
          <Button
            label="Create new post"
            to={routing.memberships.posts.create}
            appearance="primary"
            size="small"
          />
        )}
      </ButtonGroup>
    )
  }

  const renderBottomContent = () => {
    if (media.tablet) {
      return null
    }

    return <PostsSearch />
  }

  // This is a temporary solution that should be fixed once whole dashboard router is migrated to react-router 6.
  const getElement = (pathname: string): JSX.Element => {
    const tabs = getNavbarTabs()

    return (
      tabs[tabs.findIndex(({ to }) => pathname.replace(/\/$/, '') === to.replace(/\/$/, ''))]
        ?.element || React.Fragment
    )
  }

  return (
    <PageLayout size="large">
      <Dashboard.Section
        name="Posts"
        bottomContent={renderBottomContent()}
        toolbarContent={getToolbarContent()}
        bottomMargin="medium"
      >
        <Dashboard.Section.Item>
          <NavTabs tabs={getNavbarTabs()} />
        </Dashboard.Section.Item>
        <Routes>
          <Route index element={getElement(pathname)} />
        </Routes>
      </Dashboard.Section>
    </PageLayout>
  )
}
